
import { Base } from '../base-component';

import './form-item-insurance-personal.component.scss';

export class FormItemInsurancePersonal extends Base {

	form: HTMLFormElement;
	formType: any;
	selectType: Element;
	recipientInput: any;
	emailInput: any;
	subjectInput: any;
	selectProductContainer: Element;
	selectProduct: Element;
	hiddenProduct: Element;
	formFieldsContainer: Element;
	typeSelection: any;
	submitBtn: Element[];

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.selectType = this.element.querySelector('select[name=query-type]') as HTMLFormElement;
		this.selectProductContainer = this.element.querySelector('div.form-item__insurance--personal--hidden__product-select');
		this.selectProduct = this.element.querySelector('select[name=product-type]');
		this.hiddenProduct = this.element.querySelector('input[name=product-type-hidden]');
		this.formFieldsContainer = this.element.querySelector('div.form__fields--container');
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button'));

		this.recipientInput = this.element.querySelector('input[name=recipient]');
		this.emailInput = this.element.querySelector('input[name=email]');
		this.subjectInput = this.element.querySelector('input[name=subject]');

	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

		if (this.selectType) {
			this.selectType.addEventListener('change', (event: any) => this.queryType(event));
		}

		if (typeof (this.selectProduct) != 'undefined' && this.selectProduct != null) {
			this.selectProduct.addEventListener('change', (event: any) => this.productType(event));
		}

	}

	queryType(event: any) {

		let element: any = event.target;
		let value: any = element.value;
		let fieldContainer: any = this.form.querySelector('div.form__fields--container');
		let fieldClaimNumber: any = fieldContainer.querySelector('div.form__group--claim-number');

		if (fieldClaimNumber) {
			fieldContainer.removeChild(fieldClaimNumber);
		}

		this.form.setAttribute('id', 'apply-now-submit_application_insurance');
		this.typeSelection = value;

		if (typeof (this.selectProduct) != 'undefined' && this.selectProduct != null) {
			this.selectProductContainer.classList.add('form-item__insurance--personal--hidden__product-select');
			this.selectProductContainer.classList.remove('form-item__insurance--personal--hidden__product-select');
		}

		if (typeof (this.hiddenProduct) != 'undefined' && this.hiddenProduct != null) {
			let hiddenInput: any = this.hiddenProduct;
			this.recipients(hiddenInput.value);
		}

		if (value == "policyUpdates") {

			this.createInput('Policy number', 'policy-number', 'Enter your policy number');
			this.form.setAttribute('id', 'apply-now-submit_application_mail');

		} else if (value == "claimsQuery") {

			this.createInput('Policy/Claim number', 'policy-claim-number', 'Enter your policy or claim number');
			this.form.setAttribute('id', 'apply-now-submit_application_mail');

		} else {

			this.form.setAttribute('id', 'apply-now-submit_application_insurance');

		}

	}

	createInput(label: any, name: any, placeholder: any = '', required: boolean = false, type: any = '') {

		let container: any = this.formFieldsContainer;
		let fieldBefore: any = container.querySelector('div.apply-now__note');

		let fieldContainer: any = document.createElement('div');
		fieldContainer.classList.add('form__group');
		fieldContainer.classList.add('form__group--claim-number');

		let fieldLabel: any = document.createElement('label');
		fieldLabel.classList.add('form__label');
		fieldLabel.innerHTML = label;

		let fieldInput: any = document.createElement('input');
		fieldInput.classList.add('form__input');
		if (required) {
			fieldInput.classList.add('form__input--required');
		}
		fieldInput.setAttribute('type', 'text');
		fieldInput.setAttribute('name', name);
		fieldInput.setAttribute('placeholder', placeholder);

		fieldContainer.appendChild(fieldLabel);
		fieldContainer.appendChild(fieldInput);

		container.insertBefore(fieldContainer, fieldBefore);

	}

	productType(event: any) {

		let element: any = event.target;
		let value: any = element.value;
		this.recipients(value);

	}

	recipients(value: any) {

		if (this.typeSelection == "policyUpdates") {

			if (value == "348" || value == "354" || value == "355") {

				this.recipientInput.value = "SBIB.Creditlife@standardbank.co.za";
				this.emailInput.value = "SBIB.Creditlife@standardbank.co.za";

			} else if (value == "349" || value == "350" || value == "352" || value == "353") {

				this.recipientInput.value = "sbibservices@standardbank.co.za";
				this.emailInput.value = "sbibservices@standardbank.co.za";

			}

		} else if (this.typeSelection == "claimsQuery") {

			if (value == "348" || value == "352" || value == "354" || value == "355") {

				this.recipientInput.value = "creditlifeclaims@standardbank.co.za";
				this.emailInput.value = "creditlifeclaims@standardbank.co.za";

			} else if (value == "349") {

				this.recipientInput.value = "FuneralClaimsDocuments@standardbank.co.za";
				this.emailInput.value = "FuneralClaimsDocuments@standardbank.co.za";

			} else if (value == "350" || value == "353") {

				this.recipientInput.value = "stansureclient@standardbank.co.za";
				this.emailInput.value = "stansureclient@standardbank.co.za";

			}

		}

	}

}



// WEBPACK FOOTER //
// ./components/form-item-insurance-personal/form-item-insurance-personal.component.ts